import { render, staticRenderFns } from "./BackArrowIcon.vue?vue&type=template&id=654a01c9&"
import script from "./BackArrowIcon.vue?vue&type=script&lang=ts&"
export * from "./BackArrowIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports